import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/app/[locale]/(public)/error.tsx");
